import React, { useEffect, useState } from 'react'

import './Dashboard.scss'

import iconPoolValue from '../../../../../Assets/Icon/AdminDashboard/mn9vwcir-mhhbcqf.svg'
import iconActiveInvestments from '../../../../../Assets/Icon/AdminDashboard/mn9vwcir-0mzpxrh.svg'
import iconTotalInvested from '../../../../../Assets/Icon/AdminDashboard/mn9vwcis-agzq65p.svg'
import iconStations from '../../../../../Assets/Icon/AdminDashboard/mn9vwcis-lnco9mc.svg'
import tokenPoolService, { TokenPoolSnapshot } from 'Services/tokenPoolService'
import { CurrencyFormatter, handleError } from 'Helpers'
import { TimeConverter } from 'Helpers/TimeConverter'
import { formatString } from 'Helpers/formatString'
// import fillingStationService from 'Services/fillingStationService'
import investorTokenAssetsService, {
  type InvestorTokenAsset,
} from 'Services/investorTokenAssetsService'
// import financialTransactionsService from 'Services/financialTransactionsService'
import { Link } from 'react-router-dom'
import plpService from 'Services/plpService'

export interface RecentInvestment {
  id: string
  accountId: string
  customer: {
    firstName: string
    lastName: string
    msisdn: string
    emailAddress: string
    photo: {
      url: string
    }
  }
  type: string
  flowType: string
  description: string
  paidStatus: string
  amountMajor: number
  currency: string
  walletBalanceMajorBefore: number
  walletBalanceMajorAfter: number
  paymentProcessor: null
  walletType: string
  metadata: {
    transactionNote: string
    investorTokenAssetId: string
  }
  reference: string
  createdAt: string
}
const Dashboard: React.FC = () => {
  const [pool, setPool] = useState<TokenPoolSnapshot | null>(null)
  const [recentInvestmentsLoading, setRecentInvestmentsLoading] = useState(false)
  const [recentInvestmentsError, setRecentInvestmentsError] = useState<string | null>(null)
  const [recentInvestments, setRecentInvestments] = useState<InvestorTokenAsset[]>([])

  const fetchPool = async () => {
    await tokenPoolService.get().then(
      (response) => {
        setPool((response?.data?.data ?? null) as TokenPoolSnapshot | null)
      },
      (e) => {
        setPool(null)
        handleError(e)
      },
    )
  }

  const [stationsCount, setStationsCount] = useState<number>(0)
  const fetchStations = async () => {

   await plpService.index(
        1,
        'DESC',
        'ALL',
        undefined,
        undefined,
        'assigned',
      ) .then(
      (response) => {
        setStationsCount(Number(response?.data.data?.total))

        //  setPaginationData({
        //   pageNumber: response?.data.data.pageNumber,
        //   pageSize: response?.data.data.pageSize,
        //   total: response?.data.data.total,
        // }). 
      },
      (e) => {
        setStationsCount(0)
        handleError(e)
      },
    )
  }

  const [tokenCount, setTokenCount] = useState<number>(0)
  const fetchAssets = async () => {
    await investorTokenAssetsService
      .list({
        pageNumber: 1,
        pageSize: 1000,
        sortOrder: 'DESC',
        status: 'ACTIVE',
      })
      .then((response) => {
        setTokenCount(Number(response?.data?.data?.total ?? 0))
      })
  }

  const fetchRecentInvestments = async () => {
    setRecentInvestmentsLoading(true)
    setRecentInvestmentsError(null)

    await investorTokenAssetsService
      .list({
        pageNumber: 1,
        pageSize: 7,
        sortOrder: 'DESC',
        status: 'ACTIVE',
      })
      .then(
        (response) => {
          const data = response?.data?.data

          console.log({ setRecentInvestments: data?.dataset })
          setRecentInvestments((data?.dataset ?? []).slice(0, 7) as RecentInvestment[])
          setRecentInvestmentsLoading(false)
        },
        (e) => {
          setRecentInvestments([])
          setRecentInvestmentsError(
            typeof e === 'object' && e !== null && 'message' in e
              ? String((e as { message?: unknown }).message ?? 'Failed to load recent investments')
              : 'Failed to load recent investments',
          )
          setRecentInvestmentsLoading(false)
        },
      )
  }

  useEffect(() => {
    fetchPool()
    fetchStations()
    fetchAssets()
    fetchRecentInvestments()
  }, [])

  return (
    <div className='admin-dashboard'>
      <div className='admin-dashboard__greeting'>Welcome back, Admin👋</div>

      <div className='row g-3 g-xl-4'>
        <div className='col-12 col-md-6 col-xl-3'>
          <div className='admin-kpi admin-kpi--blue'>
            <div className='admin-kpi__left'>
              <div className='admin-kpi__title'>Total Pool Value</div>
              <div className='admin-kpi__value'>TGT {Number(pool?.totalTokens)}</div>
              <div className='admin-kpi__meta d-none'>Across {stationsCount} stations</div>
            </div>
            <div className='admin-kpi__icon-wrap'>
              <img src={iconPoolValue} alt='' className='admin-kpi__icon' />
            </div>
          </div>
        </div>

        <div className='col-12 col-md-6 col-xl-3'>
          <div className='admin-kpi admin-kpi--green'>
            <div className='admin-kpi__left'>
              <div className='admin-kpi__title'>Active Investments</div>
              <div className='admin-kpi__value'>{tokenCount}</div>
              <div className='admin-kpi__meta d-none'>120 investors</div>
            </div>
            <div className='admin-kpi__icon-wrap'>
              <img src={iconActiveInvestments} alt='' className='admin-kpi__icon' />
            </div>
          </div>
        </div>

        <div className='col-12 col-md-6 col-xl-3'>
          <div className='admin-kpi admin-kpi--purple'>
            <div className='admin-kpi__left'>
              <div className='admin-kpi__title'>Total Invested</div>
              <div className='admin-kpi__value'>
                ₦
                {CurrencyFormatter(
                  Number(pool?.tokenValueNairaMajor) * Number(pool?.soldTokens ?? 0),
                )}
              </div>
              <div className='admin-kpi__meta d-none d-none'>93.2% capacity</div>
            </div>
            <div className='admin-kpi__icon-wrap'>
              <img src={iconTotalInvested} alt='' className='admin-kpi__icon' />
            </div>
          </div>
        </div>

        <div className='col-12 col-md-6 col-xl-3'>
          <div className='admin-kpi admin-kpi--orange'>
            <div className='admin-kpi__left'>
              <div className='admin-kpi__title'>Stations</div>
              <div className='admin-kpi__value'>{stationsCount}</div>
              <div className='admin-kpi__meta d-none'>40 assigned · 5 unassigned</div>
            </div>
            <div className='admin-kpi__icon-wrap'>
              <img src={iconStations} alt='' className='admin-kpi__icon' />
            </div>
          </div>
        </div>
      </div>

      <div className='recent-investment'>
        <div className='admin-card recent-investment-card'>
          <div className='admin-card__header recent-investment-card__header'>
            <div>
              <div className='admin-card__title'>Recent Investments</div>
              <div className='recent-investment-card__subtitle'>
                Latest 7 investor token asset purchases
              </div>
            </div>
            <Link to='/blockchain/token-assets/ACTIVE'>
              <div className='recent-investment-card__pill'>View All</div>
            </Link>
          </div>

          <div className='recent-investment-list'>
            {recentInvestmentsLoading ? (
              <div className='recent-investment-list__empty'>Loading recent investments...</div>
            ) : recentInvestmentsError ? (
              <div className='recent-investment-list__empty'>{recentInvestmentsError}</div>
            ) : recentInvestments.length === 0 ? (
              <div className='recent-investment-list__empty'>No recent investments found</div>
            ) : (
              recentInvestments.map((investment: InvestorTokenAsset, index) => {
                return (
                  <div className='recent-investment-item' key={investment.id}>
                    <div className='recent-investment-item__index'>{index + 1}</div>

                    <div className='recent-investment-item__content'>
                      <div className='recent-investment-item__top'>
                        <div className='recent-investment-item__title'>
                          {investment?.createdByUser?.firstName}{' '}
                          {investment?.createdByUser?.firstName}
                        </div>
                        <div className='recent-investment-item__amount'>
                          ₦{CurrencyFormatter(Number(investment.principalNairaMajor ?? 0))}
                        </div>
                      </div>

                      <div className='recent-investment-item__bottom'>
                        <span className='recent-investment-item__meta'>{investment.id}</span>
                        <span className='recent-investment-item__meta'>
                          {/* {investment?.shares && investment?.shares[0]?.tokenCountOwned ?? 0} tokens */}
                        </span>
                        <span className='recent-investment-item__meta'>
                          {TimeConverter(investment.createdAt)}
                        </span>
                        <span
                          className={[
                            'recent-investment-item__status',
                            `recent-investment-item__status--${String('unknown').toLowerCase()}`,
                          ]
                            .filter(Boolean)
                            .join(' ')}
                        >
                          {formatString(investment.status)}
                        </span>
                      </div>
                    </div>
                  </div>
                )
              })
            )}
          </div>
        </div>
      </div>
      {/* <div className='row g-3 g-xl-4 mt-1 mt-xl-3'>
        <div className='col-12 col-xl-7'>
          <div className='admin-card'>
            <div className='admin-card__header'>
              <div className='admin-card__title'>Investment Trends</div>
              <button type='button' className='admin-card__filter'>
                <span>Last 30 Days</span>
                <img src={iconChevronDown} alt='' className='admin-card__filter-icon' />
              </button>
            </div>

            <div className='admin-chart'>
              <div className='admin-chart__canvas'>
                <img src={chartFill} alt='' className='admin-chart__fill' />
                <img src={chartLine} alt='' className='admin-chart__line' />
              </div>
              <div className='admin-chart__axis'>
                <span>5</span>
                <span>10</span>
                <span>15</span>
                <span>20</span>
                <span>25</span>
                <span>30</span>
              </div>
            </div>
          </div>
        </div>

        <div className='col-12 col-xl-5'>
          <div className='admin-card'>
            <div className='admin-card__header'>
              <div className='admin-card__title'>Today’s Activity</div>
            </div>

            <div className='admin-activity'>
              <div className='admin-activity__row'>
                <span className='admin-activity__bullet admin-activity__bullet--green' />
                <span className='admin-activity__text'>5 New KYC applications</span>
              </div>
              <div className='admin-activity__divider' />
              <div className='admin-activity__row'>
                <span className='admin-activity__bullet admin-activity__bullet--green' />
                <span className='admin-activity__text'>3 New KYC applications</span>
              </div>
              <div className='admin-activity__divider' />
              <div className='admin-activity__row'>
                <span className='admin-activity__bullet admin-activity__bullet--orange' />
                <span className='admin-activity__text'>3 New Investments — ₦80M</span>
              </div>
              <div className='admin-activity__divider' />
              <div className='admin-activity__row'>
                <span className='admin-activity__bullet admin-activity__bullet--green' />
                <span className='admin-activity__text'>12 Payments Processed</span>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  )
}

export default Dashboard
